<div class="sharesHeaders__tags">
  <div
    class="editAccountUserShareList__shareHeadersTagsSelect"
    ppTooltip
    [ppTitle]="ppDisabled ? disabledTooltipText : ''"
    >
    <pp-select
      [ppItems]="shareOptions"
      [ppSelectedItem]="shareOptions[index]"
      (ppSelectItem)="updatePermissions($event)"
      [ppNoSearchBar]="true"
      [ppDisabled]="ppDisabled"
      require
      >
      <ng-container selected>
        @if (index !== -1) {
          <span class="accountSettings__select-content">
            {{ shareOptions[index].label }}
          </span>
        }
      </ng-container>
    </pp-select>
  </div>
</div>
